import './component.scss'
import './images/up_arrow.svg'

document.addEventListener('DOMContentLoaded', () => {
  const backToTopButtonContainer = document.querySelector('.back-to-top-button__js-back-to-top-trigger')

  if (!backToTopButtonContainer) {
    return
  }

  const clientsCount = parseInt(backToTopButtonContainer.dataset.pageClientsCount, 10)
  const CLIENT_COUNT_THRESHOLD = 10
  const triggerClassName = clientsCount > CLIENT_COUNT_THRESHOLD ? '.js-back-to-top-trigger--card' : '.js-back-to-top-trigger--change-condition'

  // MutationObserverで要素の追加を監視
  const initBackToTop = () => {
    const triggerElement = document.querySelector(triggerClassName)
    const footer = document.querySelector('footer')

    if (triggerElement && footer) {
      document.addEventListener('scroll', () => toggleBackToTopButton(backToTopButtonContainer, triggerElement, footer))
      backToTopButtonContainer.addEventListener('click', () => scrollToTop())
      return true // 初期化完了
    }
    return false // まだ要素が見つからない
  }

  // 初回試行
  if (!initBackToTop()) {
    // 要素が見つからない場合、MutationObserverで監視
    const observer = new MutationObserver(() => {
      if (initBackToTop()) {
        observer.disconnect() // 初期化完了したら監視停止
      }
    })

    observer.observe(document.body, {
      childList: true,
      subtree: true
    })
  }

  const toggleBackToTopButton = (backToTopButtonContainer, triggerElement, footer) => {
    if (isTriggerElementPassed(triggerElement) && !isFooterPassed(footer)) {
      backToTopButtonContainer.classList.add('back-to-top-button__container--active')
    } else {
      backToTopButtonContainer.classList.remove('back-to-top-button__container--active')
    }
  }

  // TOPへ戻るボタンの表示・非表示を切り替えるエレメントに突入したかどうかを判定するメソッド
  const isTriggerElementPassed = (triggerElement) => {
    const triggerOffsetTop = triggerElement.offsetTop
    return window.scrollY + window.innerHeight > triggerOffsetTop
  }

  // フッターに突入したかどうかを判定するメソッド
  const isFooterPassed = (footer) => {
    const footerOffsetTop = footer.offsetTop
    return window.scrollY + window.innerHeight > footerOffsetTop
  }

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }
})
